import styled from 'styled-components'
import ViewPageTop from '@chegg-wt/core/components/BibliographyContainer/ViewPageTop'
import { Ellipsize } from '@chegg-wt/core/theme/sunkist/typography'

export const Layout = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor20};
`

export const Container = styled.div`
  width: 100%;
`

export const BibliographyLayoutTop = styled(ViewPageTop)`
  display: flex;

  & > :last-child {
    flex-shrink: 0;
    flex-grow: 0;
  }

  & > :first-child {
    flex-shrink: 1;
    ${Ellipsize};
  }
`
